import React from "react";
import dynamic from "next/dynamic";
import { getInitialData } from "../service/apiFetch";
import NotFound from "../components/ErrorPage/NotFound";
import Welcometoshelly from "../components/Home/Welcometoshelly";
import Banner from "../components/Home/Banner";

const Ourclasses = dynamic(() => import("../components/Home/Ourclasses"));
const Ourawesometeacher = dynamic(() => import("../components/Home/Ourawesometeacher"));
const Recentnews = dynamic(() => import("../components/Home/Recentnews"));
const Joinus = dynamic(() => import("../components/Home/Joinus"), { ssr: false });

export const getStaticProps = async () => {
  const initialData = await getInitialData("__home", {
    contentBlock: "Object",
  });

  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      error: initialData?.error || "",
    },
  };
};

export default function home({ data }) {
  if (!data) {
    return <NotFound />;
  }

  return (
    <section>
      {data?.contentBlock?.BANNER && (
        <Banner data={data?.contentBlock?.BANNER} />
      )}

      {data?.contentBlock?.WELCOME && (
        <Welcometoshelly
          data={data?.contentBlock?.WELCOME}
          secdata={data?.contentBlock?.WELCOME_IMAGES}
        />
      )}

      {data?.contentBlock?.COURSE && (
        <Ourclasses data={data?.contentBlock?.COURSE} />
      )}

      {data?.contentBlock?.OUR_AWESOME_TEACHERS && (
        <Ourawesometeacher data={data?.contentBlock?.OUR_AWESOME_TEACHERS} />
      )}

      {data?.contentBlock?.BLOG && (
        <Recentnews data={data?.contentBlock?.BLOG} />
      )}

      <Joinus />
    </section>
  );
}
